const hueFromKey = key => {
	const hash = [...key].reduce((acc, ch) => (acc * 31 + ch.charCodeAt(0)) % 360, 7);
	return `hsl(${hash}, 55%, 58%)`;
};

/**
 * A stable display color for an object key (its node uuid), for an object with no
 * color of its own: the same key always gets the same hue.
 */
export const colorForKey = key => hueFromKey(key);
